import { gql } from '@apollo/client'

const SMS_DELIVERY_REMINDER_MUTATION = gql`
  mutation SmsDeliveryReminderMutation($smsDeliveryReminder: Boolean!) {
    smsDeliveryReminderUpdate(smsDeliveryReminder: $smsDeliveryReminder) {
      id
      shouldSendSmsDeliveryReminder
    }
  }
`

export { SMS_DELIVERY_REMINDER_MUTATION }
